import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private urlSource = new BehaviorSubject<string>('');
  url$ = this.urlSource.asObservable();

  public generateBreadcrumb(url: string) {
    this.urlSource.next(url);
  }
}
